import React, { useId } from "react";
import { Progress } from "reactstrap";

/** reactstrap Progress whose inner progressbar gets an accessible name (WCAG 4.1.2). */
export default function LabelledProgress({ label, ...props }) {
  const id = useId();
  return (
    <>
      <span id={id} className="sr-only">{label}</span>
      <Progress {...props} barAriaLabelledBy={id} />
    </>);
}
